import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import MediaSection from '@/pages/home/components/MediaSection';
import CardsSection from '@/pages/home/components/CardsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import ContactSection from '@/pages/home/components/ContactSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import AppSection from '@/pages/home/components/AppSection';
import RankingSection from '@/pages/home/components/RankingSection';
import AboutSection from '@/pages/home/components/AboutSection';
import FaqSection from '@/pages/home/components/FaqSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CardsSection />
        <UpdatesSection />
        <CarouselSection />
        <ContactSection />
        <FeaturesSection />
        <CommentsSection />
        <IndexSection />
        <AppSection />
        <RankingSection />
        <AboutSection />
        <FaqSection />
        <TopicsSection />
      </main>
      <Footer />
    </div>
  );
}